// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.email-status-popup {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(44, 104, 173, 0.15);
  backdrop-filter: blur(5px);
  z-index: 999;
}
.email-status-popup .popup-card {
  background: #fff;
  border-radius: 20px;
  padding: 40px 32px;
  width: 420px;
  text-align: center;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  position: relative;
  animation: fadeIn 0.3s ease;
}
.email-status-popup .popup-card .close-btn {
  color: #2c68ad;
  position: absolute;
  top: 16px;
  right: 16px;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: transform 0.2s ease;
}
.email-status-popup .popup-card .close-btn img {
  width: 22px;
  height: 22px;
}
.email-status-popup .popup-card .close-btn:hover {
  transform: scale(1.1);
}
.email-status-popup .popup-card .logo-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  margin-bottom: 12px;
}
.email-status-popup .popup-card .logo-row .popup-icon {
  width: 48px;
  height: 48px;
}
.email-status-popup .popup-card .logo-row .popup-logo {
  height: 38px;
}
.email-status-popup .popup-card .popup-divider {
  width: 60px;
  height: 3px;
  background: #2c68ad;
  border-radius: 3px;
  margin: 0 auto 24px auto;
}
.email-status-popup .popup-card .popup-title {
  color: #2c68ad;
  font-weight: 600;
  font-size: 1.25rem;
  margin-bottom: 28px;
  line-height: 1.4;
}
.email-status-popup .popup-card .popup-btn {
  background: #2c68ad;
  color: #fff;
  font-weight: 600;
  border: none;
  border-radius: 30px;
  padding: 12px 36px;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.3s ease, transform 0.2s ease;
}
.email-status-popup .popup-card .popup-btn:hover {
  background: rgb(36.7612903226, 86.8903225806, 144.5387096774);
  transform: translateY(-2px);
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/layouts/Engagements/Campaigns/AIEmailEditor/EmailStatusPopup.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;EACA,0BAAA;EACA,YAAA;AACF;AACE;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,0CAAA;EACA,kBAAA;EACA,2BAAA;AACJ;AACI;EACE,cAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,+BAAA;AACN;AAAM;EACE,WAAA;EACA,YAAA;AAER;AAAM;EACE,qBAAA;AAER;AAEI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AAAN;AAEM;EACE,WAAA;EACA,YAAA;AAAR;AAGM;EACE,YAAA;AADR;AAKI;EACE,WAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,wBAAA;AAHN;AAMI;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AAJN;AAOI;EACE,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,qDAAA;AALN;AAOM;EACE,6DAAA;EACA,2BAAA;AALR;AAUE;EACE;IACE,UAAA;IACA,4BAAA;EARJ;EAUE;IACE,UAAA;IACA,wBAAA;EARJ;AACF","sourcesContent":[".email-status-popup {\n  position: fixed;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(44, 104, 173, 0.15);\n  backdrop-filter: blur(5px);\n  z-index: 999;\n\n  .popup-card {\n    background: #fff;\n    border-radius: 20px;\n    padding: 40px 32px;\n    width: 420px;\n    text-align: center;\n    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);\n    position: relative;\n    animation: fadeIn 0.3s ease;\n\n    .close-btn {\n      color:#2c68ad;\n      position: absolute;\n      top: 16px;\n      right: 16px;\n      background: transparent;\n      border: none;\n      cursor: pointer;\n      transition: transform 0.2s ease;\n      img {\n        width: 22px;\n        height: 22px;\n      }\n      &:hover {\n        transform: scale(1.1);\n      }\n    }\n\n    .logo-row {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 14px;\n      margin-bottom: 12px;\n\n      .popup-icon {\n        width: 48px;\n        height: 48px;\n      }\n\n      .popup-logo {\n        height: 38px;\n      }\n    }\n\n    .popup-divider {\n      width: 60px;\n      height: 3px;\n      background: #2c68ad;\n      border-radius: 3px;\n      margin: 0 auto 24px auto;\n    }\n\n    .popup-title {\n      color: #2c68ad;\n      font-weight: 600;\n      font-size: 1.25rem;\n      margin-bottom: 28px;\n      line-height: 1.4;\n    }\n\n    .popup-btn {\n      background: #2c68ad;\n      color: #fff;\n      font-weight: 600;\n      border: none;\n      border-radius: 30px;\n      padding: 12px 36px;\n      font-size: 1rem;\n      cursor: pointer;\n      transition: background 0.3s ease, transform 0.2s ease;\n\n      &:hover {\n        background: darken(#2c68ad, 7%);\n        transform: translateY(-2px);\n      }\n    }\n  }\n\n  @keyframes fadeIn {\n    from {\n      opacity: 0;\n      transform: translateY(-10px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
